

import React, { useEffect, useState } from 'react';
import memoizeOne from 'memoize-one';
import cx from 'classnames';
import { Button, Image } from '../../../../../ui-kit';
import ProgressSummary from './ProgressSummary';
import fileTypeIconMap from '../../../../../common/constants/fileTypeIconMap';
import { getTypeFromAsset } from '../../../../../common/utils';
import { uploadEvents } from '../../../utils/UploadEvents';
import '../styles/_upload-item.scss';














const retryFile = memoizeOne((retry, assetId, organisationId) => (event) => {
  const { target: { files: [file] } } = event;

  return retry(assetId, organisationId, file);
});

const removeUploadItem = memoizeOne((remove, assetId) => () => remove(assetId));

function browseFiles(id) {
  return () => {
    const element = document.getElementById(id);
    return element && element.click();
  };
}

function UploadItem({
  filename,
  loadedPercent: initialLoadedPercent,
  loaded: initialLoaded,
  status,
  totalSize: initialTotalSize,
  retry,
  remove,
  assetId,
  organisationId,
  metaData
}) {
  const fileTypeIcon = fileTypeIconMap[getTypeFromAsset({ metaData, filename })];
  const id = `${assetId}-upload-item}`;
  // Local state for progress
  const [progress, setProgress] = useState({
    loaded: initialLoaded,
    totalSize: initialTotalSize,
    loadedPercent: initialLoadedPercent
  });

  useEffect(() => {
    function onProgress({ assetId: incomingAssetId, loaded, totalSize, loadedPercent }) {
      if (incomingAssetId === assetId) {
        setProgress({ loaded, totalSize, loadedPercent });
      }
    }
    uploadEvents.on('progress', onProgress);
    return () => uploadEvents.off('progress', onProgress);
  }, [assetId]);

  const calculatedPercentage = Math.floor(progress.loaded / progress.totalSize * 100);
  const percentage = progress.loadedPercent || calculatedPercentage;

  return (
    <div className="upload-item">
      {
      status === 'error' && retry && assetId ?

      <div className="upload-item__reset-upload">
              <input
          id={id}
          type="file"
          onChange={retryFile(retry, assetId, organisationId)} />

              <Button
          prefix="folder"
          tooltipId={`${id}-tooltip`}
          tooltipLabel="Browse for this file and resume uploading"
          tooltipPlace="right"
          type="TERTIARY"
          onClick={browseFiles(id)} />

            </div> :


      <Image
        defaultImageIcon={fileTypeIcon}
        height="40px"
        width="40px"
        backgroundSize="cover"
        rounded />}



      <div
        className={cx(
          'upload-item__details',
          { 'upload-item__details--no-progress': progress.loaded === 0 && status !== 'error' },
          { 'upload-item__details--error': status === 'error' }
        )}>

        <p>{filename}</p>
        <ProgressSummary
          loadedPercent={percentage}
          loaded={progress.loaded}
          removeUploadItem={removeUploadItem(remove, assetId)}
          total={progress.totalSize}
          status={status} />

      </div>
    </div>);

}

export default UploadItem;